module.exports = __webpack_public_path__ + "b6580e5570d7235c4da6d3feaf566eb1.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=1400!./images/projekte/theater-2014.jpg
// module id = 817
// module chunks = 0